export enum ICON_HUES {
  BLUE = 'BLUE',
  ORANGE = 'ORANGE',
  RED = 'RED',
  YELLOW = 'YELLOW',
  GREEN = 'GREEN',
  PURPLE = 'PURPLE',
}
